import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { QueryOptions, Message } from '@models/system';
import { type HttpService } from '@http/services';
import { Order } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class OrderService implements HttpService<Order> {

    constructor(private http: HttpClient) {}

    fetch(qo: QueryOptions) : Observable<HttpResponse<Order[]>> {
        return this.http.get<Order[]>(env.API_URL + '/orders', {
            params: qo.toObject(), // { offset: qo.offset, limit: qo.limit, eq: qo.eq, dig: qo.dig}, 
            observe: 'response'
        });
    }

    get(id: string) : Observable<HttpResponse<Order>> {
        return this.http.get<Order>(env.API_URL + '/orders/' + id, {
            params: {},
            observe: 'response'
        }).pipe(
            map( resp => {
                if (resp.body != null && resp.body.order_id) {
                    //resp.body.datetime = DateService.toDateString(resp.body.datetime);
                }
                return resp;
            })
        );
    }

    post(t: Order): Observable<HttpResponse<Order>> {
        //return throwError(() => new Error("Invalid API service call attempt"));
        return this.http.post<Order>(env.API_URL + '/orders', t, {
            params: {},
            observe: 'response'
        });
    }

    put(t: Order): Observable<HttpResponse<Message>> { 
        //return throwError(() => new Error("Invalid API service call attempt"));
        return this.http.put<Message>(env.API_URL + '/orders/' + t.order_id, t, {
            params: {},
            observe: 'response'
        });
    }

    delete(id: string) : Observable<HttpResponse<Message>> {
        //return throwError(() => new Error("Invalid API service call attempt"));
        return this.http.delete<Message>(env.API_URL + '/orders/' + id, {
            params: {},
            observe: 'response'
        });
    }

}
